<template>
  <div class="pretest">
    <div class="main-content">
      <div class="title">
        <h2>候考</h2>
        <p class="tip">
          考试开始前，请考生<strong>在此页面耐心等待</strong>。<span
            v-if="needIdentity"
            >如退出，考生需重新登录进行身份核验。</span
          >
        </p>
      </div>
      <div class="time-wrap" v-if="examReady && testInfo.start_time && !hasNoTest">
        <div class="time">
          <countdown
            :key="countdownKey"
            :remoteTime="testInfo.start_time"
            @listen="listen"
            @sync-state="onClockSync"
          ></countdown>
        </div>
        <p class="time-txt">
          <span>小时</span><span class="time-space">分钟</span><span>秒</span>
        </p>
      </div>
      <div class="info-wrap">
        <h3>考生信息</h3>
        <div class="info" v-if="!hasNoTest">
          <template v-if="!loading">
            <template v-if="shandongKeXieInfo">
              <div class="row" v-if="testInfo.start_time">
                <span class="label">开考时间</span>
                <span class="text">{{ testInfo.start_time | date }}</span>
              </div>
              <div class="row" v-if="testInfo.exam_time">
                <span class="label">考试时长</span>
                <span class="text">{{ testInfo.exam_time }}分钟</span>
              </div>
              <div class="row" v-if="shandongKeXieInfo.level">
                <span class="label">赛级</span>
                <span class="text">{{ shandongKeXieInfo.level }}</span>
              </div>
              <div class="row" v-if="shandongKeXieInfo.group">
                <span class="label">组别</span>
                <span class="text">{{ shandongKeXieInfo.group }}</span>
              </div>
              <div class="row" v-if="shandongKeXieInfo.event">
                <span class="label">赛项</span>
                <span class="text" style="width: 250px">{{
                  shandongKeXieInfo.event
                }}</span>
              </div>
            </template>
            <template v-else>
              <div class="row" v-if="testInfo.exam_name">
                <span class="label">考试名称</span>
                <span class="text">{{ testInfo.exam_name }}</span>
              </div>
              <div
                class="row"
                v-if="
                  testInfo.name &&
                  (testConfig.show_examinee_name || isTouristsId)
                "
              >
                <span class="label">{{
                  isChongQing ? "用户名" : "考生姓名"
                }}</span>
                <span class="text">{{ testInfo.name }}</span>
              </div>
              <div class="row" v-if="testInfo.identity_num">
                <span class="label">身份证号码</span>
                <span class="text">{{ testInfo.identity_num }}</span>
              </div>
              <div
                class="row"
                v-if="
                  testInfo.start_time &&
                  $route.path.split('/')[1].indexOf(weishengRoute) < 0
                "
              >
                <span class="label">开考时间</span>
                <span class="text">{{ testInfo.start_time | date }}</span>
              </div>

              <div class="row" v-if="testInfo.mobile">
                <span class="label">手机号码</span>
                <span class="text">{{ testInfo.mobile }}</span>
              </div>

              <div class="row" v-if="testInfo.exam_time">
                <span class="label">考试时长</span>
                <span class="text">{{ testInfo.exam_time }}分钟</span>
              </div>

              <div class="row" v-if="testInfo.school">
                <span class="label">所在学校</span>
                <span class="text">{{ testInfo.school }}</span>
              </div>

              <div class="row" v-if="testInfo.score">
                <span class="label">卷面总分</span>
                <span class="text">{{ testInfo.score }}分</span>
              </div>
              <div class="row" v-if="testInfo.area">
                <span class="label">所在地区</span>
                <span class="text">{{ testInfo.area }}</span>
              </div>

            </template>
          </template>
        </div>
        <div v-else class="no-info">
          <p class="icon"></p>
          <p class="error-tip">考试卷正在配置中</p>
        </div>
      </div>

      <div class="bottom">
        <div
          v-if="!canShowRetake && isShowDetectTip && (theme.deviceCheckOpen || isDoubleCameraMonitor)"
          class="pretest-tip"
        >
          <p>开考前，请确保设备可用并经过了检测，以免影响考试</p>
          <img @click="isShowDetectTip = false" src="@/assets/images/icon-black-close.png" alt="close" />
        </div>
        <template v-if="hasNoTest">
          <button class="close-btn" @click="close">知道了</button>
        </template>
        <template v-else>
          <p v-if="testInfo.isLate" class="error-tip">
            迟到{{ testInfo.last_come_in_minute }}分钟，禁止进入考场
          </p>
          <template v-else>
            <div
              v-if="canShowRetake && isShowRetakeTip"
              class="pretest-tip retake-tip"
            >
              <p>该考试已完成交卷，重考将会清除上次考试作答记录</p>
              <img @click="isShowRetakeTip = false" src="@/assets/images/icon-black-close.png" alt="close" />
            </div>
            <button
              @click="goDetect"
              class="check-btn check-btn__bubble"
              :class="{
                'check-btn__complete_bubble': isFinishedDoubleCameraDetect && isDoubleCameraMonitor,
                'check-btn__not_complete_bubble': !isFinishedDoubleCameraDetect && isDoubleCameraMonitor
              }"
              v-if="theme.deviceCheckOpen || isDoubleCameraMonitor"
            >
              {{
                isDoubleCameraMonitor
                  ? '双机位环境检测'
                  : '设备检测'
              }}
            </button>
            <button
              v-if="canShowRetake"
              class="start-btn"
              :disabled="retakeButtonDisabled"
              :class="{ disabled: retakeButtonDisabled }"
              @click="resetAndStartTest"
            >
              <span v-show="retakeLoading">
                <loading
                  :box-size="4"
                  :round-size="1"
                  :color="'#fff'"
                ></loading>
              </span>
              重考
            </button>
            <button
              v-else
              class="start-btn"
              :disabled="startButtonDisabled"
              :class="{ disabled: startButtonDisabled }"
              @click="startTest"
            >
              <span v-show="btnLoading">
                <loading
                  :box-size="4"
                  :round-size="1"
                  :color="'#fff'"
                ></loading>
              </span>
              开始考试
            </button>
          </template>
        </template>
      </div>
    </div>
    <detect-tip-modal
      ref="detectRef"
      v-show="showDetectModal"
      @close="showDetectModal = false"
      @goTest="startTest(false)"
    ></detect-tip-modal>
    <commitment-modal
      v-if="examReady"
      :key="activeExamId"
      v-show="showCommitmentModal"
      @close="showCommitmentModal = false"
      @goTest="startTest(false)"
    ></commitment-modal>
  </div>
</template>

<script>
import Countdown from '@/components/Countdown'
import { mapState } from 'vuex'
import { post, get } from '@/utils/ajax'
import { getTouristsVal, getExamId } from '@/utils'
import Loading from '@/components/Loading'
import DetectTipModal from '@/views/components/DetectTipModal'
import CommitmentModal from '@/views/components/CommitmentModal'
import axios from 'axios'
import { checkExamIdCard } from '@/apis/exam.api'
import { isDoubleCameraDetectFinished } from '@/views/Detect/pc/helper/detectFinish.helper.js'
import { isValidServerTime } from '@/utils/serverTime'

export default {
  components: {
    Countdown,
    Loading,
    DetectTipModal,
    CommitmentModal
  },
  computed: {
    ...mapState(['weishengRoute', 'theme']),
    testInfo() {
      return this.waitingInfo
    },
    testConfig() {
      return this.waitingConfig
    },
    requestedExamId() {
      return String(this.$route.query.examId || getExamId() || '')
    },
    countdownKey() {
      return `${this.activeExamId}:${this.testInfo.start_time}`
    },
    canStartExam() {
      return !this.disposed && this.examReady && this.clockReady && this.startConfirmed &&
        !this.refreshingExam && this.activeExamId === this.requestedExamId &&
        String(this.testInfo.exam_id) === this.activeExamId &&
        Number(this.testInfo.exam_status) === 2 &&
        Number(this.testInfo.examinee_status) < 4 &&
        isValidServerTime(this.testInfo.start_time) &&
        this.serverTime >= this.testInfo.start_time &&
        !this.hasNoTest && !this.testInfo.isLate
    },
    showTime() {
      return !this.canStartExam
    },
    startButtonDisabled() {
      return !this.canStartExam || this.btnLoading || this.startRequestPending
    },
    canShowRetake() {
      if (!this.examReady || this.hasNoTest || this.testInfo.isLate) return false
      if (Number(this.testInfo.exam_status) !== 2) return false
      const status = Number(this.testInfo.examinee_status)
      const submitted = status === 4
      const supportRetake = Number(this.waitingExamConfig.repeat_test) === 1
      return submitted && supportRetake
    },
    retakeButtonDisabled() {
      return this.retakeLoading || this.btnLoading || this.startRequestPending
    },
    isDoubleCameraMonitor() {
      if (!this.testConfig) {
        return false
      }

      if (!this.testConfig.cameraOption) {
        return false
      }

      return this.testConfig.cameraOption.includes('double_camera_monitor')
    },
    isFinishedDoubleCameraDetect() {
      return isDoubleCameraDetectFinished()
    },
    // 重庆科协考试判断
    isChongQing() {
      const path = sessionStorage.getItem('path')
      const arrPath = ['mncq', 'zscq', 'cq']
      const examId = getExamId()
      const arr = [
        '1617',
        '1618',
        '1619',
        '1620',
        '3907',
        '3911',
        '3909',
        '3910'
      ]
      return arr.includes(examId) || arrPath.includes(path)
    },
    // 判断是否是游客账号
    isTouristsId() {
      const isTourists = getTouristsVal()
      return !!isTourists
    },
    // 山东科协项目
    shandongKeXieInfo() {
      return this.shandongKeXieList.find(
        (el) => el.examId === this.testInfo.exam_id
      )
    }
  },
  watch: {
    '$route.query.examId'() {
      this.initializeExam()
    },
    'testInfo.start_time'() {
      this.clockReady = false
      this.startConfirmed = false
      this.setStartFlag(false)
    },
    canStartExam(value) {
      this.setStartFlag(value)
    },
    showDetectModal(val) {
      if (val) {
        this.$refs.detectRef.open(this.testInfo.exam_id, this.isDoubleCameraMonitor)
      }
    }
  },
  data() {
    return {
      loading: true,
      waitingInfo: {},
      waitingConfig: {},
      waitingExamConfig: {},
      activeExamId: '',
      examReady: false,
      clockReady: false,
      startConfirmed: false,
      refreshingExam: false,
      serverTime: 0,
      examVersion: 0,
      profileVersion: 0,
      retryTimer: null,
      disposed: false,
      hasNoTest: false,
      time: 0,
      needIdentity: false,
      btnLoading: false,
      retakeLoading: false,
      startRequestPending: false,
      showDetectModal: false,
      shandongKeXieList: [],
      showCommitmentModal: false,
      isShowDetectTip: true,
      isShowRetakeTip: true
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.onVisibilityChange)
    window.addEventListener('pageshow', this.onPageShow)
    this.initializeExam()
  },
  beforeDestroy() {
    this.disposed = true
    this.examVersion++
    this.profileVersion++
    clearTimeout(this.retryTimer)
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    window.removeEventListener('pageshow', this.onPageShow)
  },
  methods: {
    isCurrentExam(version) {
      return !this.disposed && version === this.examVersion &&
        this.activeExamId === this.requestedExamId
    },
    setStartFlag(value) {
      this.$set(this.waitingInfo, 'startExaminee', value)
      const stored = this.$store.state.testInfo
      if (stored && String(stored.exam_id) === this.activeExamId && stored.startExaminee !== value) {
        this.$store.commit('SETSTATE', {
          key: 'testInfo', value: { ...stored, startExaminee: value }
        })
      }
    },
    async initializeExam() {
      if (this.disposed) return
      this.setStartFlag(false)
      const version = ++this.examVersion
      this.profileVersion++
      clearTimeout(this.retryTimer)
      this.retryTimer = null
      this.activeExamId = this.requestedExamId
      this.waitingInfo = {}
      this.waitingConfig = {}
      this.waitingExamConfig = {}
      this.examReady = false
      this.clockReady = false
      this.startConfirmed = false
      this.btnLoading = false
      this.retakeLoading = false
      this.serverTime = 0
      this.hasNoTest = false
      this.showDetectModal = false
      this.showCommitmentModal = false
      if (!this.activeExamId) {
        this.$router.push({ name: 'list' })
        return
      }
      localStorage.examId = this.activeExamId
      try {
        if (!this.$store.state.user || !this.$store.state.user.id) {
          await this.$store.dispatch('getCodemaoUserInfo')
        }
        if (!this.isCurrentExam(version)) return
        const ready = await this.refreshExam({ loadConfig: true, syncTime: false })
        if (!ready || !this.isCurrentExam(version)) return
        this.fetchShandongKexie()
        this.$store.dispatch('setMonitorReport', { type: 3 })
      } catch (error) {
        if (this.isCurrentExam(version)) this.scheduleRetry()
      }
    },
    async refreshExam({ loadConfig = false, syncTime = true, silent = false } = {}) {
      const version = this.examVersion
      if (!this.isCurrentExam(version)) return false
      const request = ++this.profileVersion
      const examId = this.activeExamId
      const user = this.$store.state.user || {}
      const isCurrent = () => this.isCurrentExam(version) && request === this.profileVersion
      clearTimeout(this.retryTimer)
      this.retryTimer = null
      this.refreshingExam = true
      this.clockReady = false
      this.startConfirmed = false
      this.setStartFlag(false)
      try {
        const [profile, config, time] = await Promise.all([
          get(`/home/exams/${examId}/examinees/${user.id}/profile`, {}, { ignoreMsg: true }),
          loadConfig ? get(`/home/exams/check/${examId}`, {}, { ignoreMsg: true }) : null,
          syncTime ? get('/home/common/times', {}, { ignoreMsg: true }) : null
        ])
        if (!isCurrent()) return false
        if (!profile || !profile.examinee_id || !isValidServerTime(profile.start_time) ||
          (profile.exam_id != null && String(profile.exam_id) !== examId) ||
          (syncTime && !isValidServerTime(time))) {
          throw new Error('Invalid exam information')
        }
        if (loadConfig) {
          const { exam_config, identity_verification, exam_type } = config
          const parsed = {
            cameraOption: [], identityVerification: identity_verification, examType: exam_type
          }
          exam_config.forEach(({ label, actual_value }) => {
            const key = label.split('#')[1]
            if (actual_value === '1') parsed.cameraOption.push(key)
            parsed[key] = isNaN(actual_value) ? actual_value : +actual_value
          })
          this.waitingConfig = parsed
          this.waitingExamConfig = config
          this.$store.commit('SETSTATE', { key: 'testConfig', value: parsed })
          this.$store.commit('SETSTATE', { key: 'examConfig', value: config })
        }
        this.waitingInfo = {
          ...profile,
          exam_id: examId,
          start: true,
          startExaminee: false,
          avatar_url: user.avatar_url,
          account: localStorage.currentAccount,
          isLate: false
        }
        this.hasNoTest = Number(profile.exam_status) === 0
        this.examReady = true
        localStorage.examineeId = profile.examinee_id
        this.$store.commit('SETSTATE', { key: 'testInfo', value: this.waitingInfo })
        this.$store.commit('SET_EXAMINEE_INFO', this.waitingInfo)
        if (syncTime) {
          this.serverTime = time
          this.clockReady = true
          this.startConfirmed = time >= profile.start_time
          this.updateLateStatus()
        }
        if ([3, 4].includes(Number(profile.exam_status))) {
          this.$message.warning('考试已结束或已中止')
          this.$router.push({ name: 'list' })
        } else if (
          this.isTouristsId &&
          Number(profile.examinee_status) >= 4 &&
          !this.canShowRetake
        ) {
          this.$message.info('答卷已提交')
          this.$router.push({ name: 'list' })
        }
        return true
      } catch (error) {
        if (isCurrent()) {
          this.examReady = false
          if (!silent) this.reportExamError(error)
          this.scheduleRetry()
        }
        return false
      } finally {
        if (isCurrent()) {
          this.refreshingExam = false
          this.setStartFlag(this.canStartExam)
          if (Number(this.testInfo.exam_status) === 1 && this.serverTime >= this.testInfo.start_time) {
            this.scheduleRetry()
          }
        }
      }
    },
    scheduleRetry() {
      if (this.disposed || this.retryTimer || document.hidden) return
      const version = this.examVersion
      this.retryTimer = setTimeout(() => {
        this.retryTimer = null
        if (!this.isCurrentExam(version) || this.btnLoading || this.retakeLoading) return
        this.refreshExam({ loadConfig: !this.waitingConfig.cameraOption, silent: true })
      }, 5000)
    },
    reportExamError(error) {
      if (!error) return
      this.$message.warning(error.error_msg || '考试信息获取失败，请稍后重试')
      if ([20612006, 20612004, 20612005].includes(Number(error.error_code))) {
        this.$router.replace({ name: 'list' })
      }
    },
    onVisibilityChange() {
      if (!document.hidden) {
        this.initializeExam()
      } else {
        this.examVersion++
        this.profileVersion++
        this.clockReady = false
        this.startConfirmed = false
        this.setStartFlag(false)
        clearTimeout(this.retryTimer)
        this.retryTimer = null
      }
    },
    onPageShow(event) {
      if (event.persisted && !document.hidden) this.initializeExam()
    },
    onClockSync(ready) {
      if (!this.examReady || !this.isCurrentExam(this.examVersion)) return
      this.clockReady = ready && !document.hidden
      if (ready) {
        clearTimeout(this.retryTimer)
        this.retryTimer = null
      } else {
        this.startConfirmed = false
        this.setStartFlag(false)
        this.scheduleRetry()
      }
    },
    updateLateStatus() {
      const { last_come_in_minute, start_time, examinee_status } = this.testInfo
      this.$set(this.waitingInfo, 'isLate', !!Number(last_come_in_minute) &&
        Number(examinee_status) === 0 && this.serverTime >= start_time + last_come_in_minute * 60000)
    },
    listen(time) {
      if (!this.examReady || !this.clockReady || this.refreshingExam ||
        !this.isCurrentExam(this.examVersion) || document.hidden) return
      if (!isValidServerTime(time)) {
        this.onClockSync(false)
        return
      }
      this.serverTime = time
      this.updateLateStatus()
      if (time < this.testInfo.start_time) {
        clearTimeout(this.retryTimer)
        this.retryTimer = null
        this.startConfirmed = false
      } else if (!this.startConfirmed && !this.retryTimer && !this.btnLoading && !this.retakeLoading) {
        this.refreshExam({ silent: true })
      } else if (this.canStartExam) {
        clearTimeout(this.retryTimer)
        this.retryTimer = null
      }
    },
    async close() {
      this.$router.push({ name: 'list' })
    },
    async resetAndStartTest() {
      if (!this.canShowRetake || this.retakeButtonDisabled) return
      const version = this.examVersion
      this.retakeLoading = true
      try {
        await post(`/home/edu/examinees/exams/reset`, {
          exam_id: this.activeExamId,
          examinee_id: this.testInfo.examinee_id
        }, { ignoreMsg: true })
        if (!this.isCurrentExam(version)) return
        localStorage.removeItem('currentQuestionId')
        const valid = await this.refreshExam({ silent: true })
        if (!valid || !this.isCurrentExam(version)) return
        if (this.canShowRetake) {
          this.$message.warning('重考状态刷新失败，请稍后重试')
          return
        }
        this.retakeLoading = false
        await this.startTest()
      } catch (error) {
        if (this.isCurrentExam(version)) this.reportExamError(error)
      } finally {
        if (this.isCurrentExam(version)) this.retakeLoading = false
      }
    },
    async startTest(needCheckDevice = true) {
      if (this.startButtonDisabled) return
      const version = this.examVersion
      const examId = this.activeExamId
      let startSent = false
      this.btnLoading = true
      try {
        if (
          this.testConfig.examType !== 3 && // 不是敏捷考试
          this.testConfig.identityVerification // 需要上传身份证
        ) {
          const { has_face_info } = await checkExamIdCard(examId)
          if (!this.isCurrentExam(version)) return
          if (!has_face_info) {
            this.$router.push({ name: 'identityCheck', query: { examId } })
            return
          }
        }

        if (this.theme.deviceCheckOpen && needCheckDevice) {
          if (this.isDoubleCameraMonitor) {
            if (!isDoubleCameraDetectFinished()) {
              this.showDetectModal = true
              return
            }
          } else {
            const needsDetect = await this.checkDetect()
            if (!this.isCurrentExam(version)) return
            this.showDetectModal = needsDetect
            if (needsDetect) return
          }
        }
        const showCommitment = await this.checkOpenCommitment()
        if (!this.isCurrentExam(version)) return
        if (showCommitment) {
          this.showCommitmentModal = true
          return
        }

        const valid = await this.refreshExam()
        if (!valid || !this.isCurrentExam(version) || !this.canStartExam) return
        this.startRequestPending = true
        startSent = true
        await post(`/home/edu/examinees/start/${examId}/${this.testInfo.examinee_id}`, {}, { ignoreMsg: true })
        if (!this.isCurrentExam(version)) return
        localStorage.setItem('user_id', this.$store.state.user.id)
        localStorage.removeItem('currentQuestionId')
        this.$router.push({ name: 'test', query: { examId }, params: { noAllowBack: true } })
      } catch (error) {
        if (this.isCurrentExam(version)) this.reportExamError(error)
      } finally {
        if (startSent) this.startRequestPending = false
        if (this.isCurrentExam(version)) this.btnLoading = false
      }
    },
    async checkDetect() {
      // 判断该设备是否需要设备检测
      const finger = this.$store.state.browserFinger
      const { deviceCheckInfo } = await get(
        `/home/devices/check/info?serialNumber=${finger}`
      )
      return Object.values(deviceCheckInfo).some(
        ({ deviceStatus, deviceType }) =>
          this.theme.deviceTypes.includes(deviceType) && !deviceStatus
      )
    },
    goDetect() {
      this.$refs.detectRef.goDetect()
    },
    // 拉取山东科协考试数据列表
    async fetchShandongKexie() {
      const version = this.examVersion
      try {
        this.loading = true
        const env = CONFIG.env === 'production' ? '' : `-${CONFIG.env}`
        const { data } = await axios.get(
          `https://static.codemao.cn/shandongkexie${env}.json`,
          { params: { _: Date.now() }, withCredentials: false }
        )
        if (!this.isCurrentExam(version)) return
        this.loading = false
        if (data) {
          this.shandongKeXieList = data
        }
      } catch (e) {
        if (!this.isCurrentExam(version)) return
        this.loading = false
      }
    },
    // 检测是否需要弹考试承诺
    async checkOpenCommitment() {
      const { exam_config } = this.waitingExamConfig
      const examId = this.activeExamId
      // 是否配置了考前承诺，1 配置，0 未配置
      const commitmentConfig = exam_config.find(
        (item) => item.label === 'LARGE_EXAM#exam_commitment'
      )
      const commitment = commitmentConfig && commitmentConfig.actual_value
      const isAgreeOfExamId = localStorage.getItem(`exam_commitment_${examId}`)
      return !!parseInt(commitment) && !isAgreeOfExamId
    }
  }
}
</script>

<style lang="scss" scoped>
.pretest {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  background-color: #fafafa;
  padding: 30px 0;
}
.main-content {
  width: 1000px;
  min-height: 560px;
  background-color: #fff;
  margin: 0 auto;
  text-align: center;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding-bottom: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  h2 {
    font-size: 27px;
    font-weight: 500;
    color: #333;
    padding: 40px 0 6px 0;
  }
}
.tip {
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.5px;
  font-weight: 300;
}
.time-wrap {
  .time {
    font-size: 48px;
    font-weight: 500;
    height: 46px;
    line-height: 48px;
    text-align: center;
    margin: 22px auto -2px;
    color: #306fff;
  }
  .time-txt {
    display: flex;
    justify-content: center;
  }
  .time-space {
    margin: 0 84px 0 80px;
  }
  span {
    font-size: 12px;
    color: #306fff;
    font-weight: 300;
  }
}
.info-wrap {
  width: 920px;
  min-height: 200px;
  margin: 30px auto;
  background-color: #fafafa;
  padding-bottom: 25px;
  h3 {
    font-size: 21px;
    color: #333;
    letter-spacing: 1px;
    padding: 20px 0 26px 0;
  }
  .info {
    width: 630px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 auto;
  }
  .row {
    text-align: left;
    margin-bottom: 12px;
    display: flex;
    font-size: 16px;
  }
  .label {
    position: relative;
    display: inline-block;
    padding-right: 16px;
    width: 85px;
    text-align: justify;
    text-align-last: justify;
    font-weight: 500;
    &:after {
      position: absolute;
      content: "：";
    }
  }
  .text {
    display: inline-block;
    width: 200px;
    font-weight: 300;
  }
  .no-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon {
      width: 100px;
      height: 87px;
      background: url("~@/assets/images/none.png") center/cover no-repeat;
      margin: 30px auto 16px auto;
    }
  }
}
.error-tip {
  color: #ff5030;
  font-size: 14px;
}
.bottom {
  width: 920px;
  margin: 0 auto;
  border-top: 1px solid #f0f0f0;
  padding-top: 25px;
  .pretest-tip {
    font-size: 12px;
    color: #F5222D;
    margin: auto;
    margin-bottom: 20px;
    border: 1px solid #FFCCC7;
    background: #FFF1F0;
    width: fit-content;
    padding: 2px 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    img {
      width: 8px;
      height: 8px;
      margin-left: 8px;
      cursor: pointer;
    }
  }
  .close-btn {
    @include theme-fill-btn(136px, 40px, 16px, 4px);
  }
  .start-btn {
    @include theme-fill-btn(240px, 40px, 16px, 4px);
    &:hover {
      opacity: 0.8;
    }
    &.disabled {
      background: #b5c6e4 !important;
      box-shadow: none !important;
      cursor: not-allowed !important;
      color: #fff;
      &:hover {
        opacity: 1;
      }
    }
    /deep/.spinner {
      margin-right: 4px;
      display: inline-block;
    }
  }
  .check-btn {
    @include theme-empty-btn(240px, 40px, 16px, 4px);
    margin-right: 10px;
    position: relative;
    &:hover {
      border-width: 1px;
      line-height: 38px;
    }
  }

  .check-btn__bubble::after {
    position: absolute;
    top: -10px;
    left: -1px;
    font-size: 10px;
    line-height: 15px;
    display: flex;
    justify-content: center;
    padding: 2px 5px;
    border-radius: 2px;
    color: #ffffff;
    width: 52px;
    border-radius: 20px 20px 20px 0;
  }

  .check-btn__not_complete_bubble::after {
    content: '未完成';
    background-color: #FF7A45;
  }
  .check-btn__complete_bubble::after {
    content: '已完成';
    background-color: #73D13D;
  }
}
</style>
